import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PaylocComponent } from './payloc.component';
import { PaylocListComponent } from './payloc-list/payloc-list.component';
import { PaylocMenuComponent } from './payloc-menu/payloc-menu.component';
import { AuthGuard } from '../auth/auth.guard';
import {HomeComponent} from "./home/home.component";
import { SubpaymentFormComponent } from './subpayment-form/subpayment-form.component';


export const paylocRoutes: Routes = [
  { path: 'home', canActivate: [AuthGuard], component: HomeComponent },
  {
    path: 'payloc', canActivate: [AuthGuard], children: [
      { path: '', component: PaylocComponent },
      { path: 'list', component: PaylocListComponent, data: { menuComponent: PaylocMenuComponent } },
      { path: 'add', component:  SubpaymentFormComponent},
      { path: 'subpayment', component: SubpaymentFormComponent},
      {
        path: ':id', children: [
          { path: '', component: SubpaymentFormComponent },
          { path: 'edit', component: SubpaymentFormComponent }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(paylocRoutes)],
  exports: [RouterModule]
})
export class PaylocRoutingModule { }
